import { useNavigate } from 'react-router-dom';

function Pricing() {
  const navigate = useNavigate();

  const handleGetStarted = (plan) => {
    // Navigate to register page with pre-selected plan
    navigate('/register', { state: { memberCount: plan } });
  };

  return (
    <section id="pricing" className="py-16">
      <div className="container mx-auto px-4">
        {/* Section Title */}
        <h2 className="text-3xl font-bold text-center mb-4 text-gray-900">
          Simple, Transparent Pricing
        </h2>
        <p className="text-center text-gray-600 mb-12">
          One flat rate per chapter, per semester. All features included.
        </p>

        {/* Pricing Cards */}
        <div className="flex flex-col md:flex-row justify-center gap-8 max-w-5xl mx-auto">
          {/* Standard Card */}
          <div className="border border-gray-300 rounded-lg p-8 w-full md:w-1/3 text-center hover:shadow-lg transition-shadow">
            <h3 className="text-2xl font-bold text-gray-900 mb-2">
              Standard Chapter
            </h3>
            <p className="text-gray-600 mb-6">
              Up to 100 Members
            </p>
            <div className="mb-6">
              <span className="text-5xl font-bold text-gray-900">$150</span>
              <span className="text-gray-600"> / semester</span>
            </div>
            <button 
              onClick={() => handleGetStarted('standard')}
              className="w-full py-3 px-6 bg-white border-2 rounded-md font-semibold transition"
              style={{ color: '#a60533', borderColor: '#a60533' }}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#fce7ed'}
              onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}
            >
              Get Started
            </button>
          </div>

          {/* Large Card - Featured */}
          <div className="border-2 rounded-lg p-8 w-full md:w-1/3 text-center relative hover:shadow-xl transition-shadow" style={{ borderColor: '#a60533' }}>
            {/* Best Value Badge */}
            <div className="absolute -top-3 left-1/2 transform -translate-x-1/2 text-white px-3 py-1 rounded-full text-sm font-semibold" style={{ backgroundColor: '#a60533' }}>
              Best Value
            </div>

            <h3 className="text-2xl font-bold text-gray-900 mb-2">
              Large Chapter
            </h3>
            <p className="text-gray-600 mb-6">
              100+ Members
            </p>
            <div className="mb-6">
              <span className="text-5xl font-bold text-gray-900">$200</span>
              <span className="text-gray-600"> / semester</span>
            </div>
            <button 
              onClick={() => handleGetStarted('large')}
              className="w-full py-3 px-6 text-white rounded-md font-semibold transition" 
              style={{ backgroundColor: '#a60533' }}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#8a0429'}
              onMouseLeave={(e) => e.target.style.backgroundColor = '#a60533'}
            >
              Get Started
            </button>
          </div>
        </div>

      </div>
    </section>
  );
}

export default Pricing;
